// extracted by mini-css-extract-plugin
export default {"notFound":"style_notFound__oRz07","wrap":"style_wrap__eP5zb"};